import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { CURRICULUM_HIGHLIGHTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/curriculum-highlights/new")({
  component: () => <DeptContentForm cfg={CURRICULUM_HIGHLIGHTS} />,
});
